import styled from "styled-components";

export const Title = styled.p`
  color: ${(props) => props.theme["@default-color"]};
  font-size: 20px;
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;

export const DrawerFooter = styled.div`
  width: 100%;
  padding: 10px 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-color: ${(props) => props.theme["@footer-background"]};
  .left {
    text-align: left;
  }
  .right {
    text-align: right;
    display: flex;
    margin-left: auto;
    gap: ${(props) => props.theme["@spacing-size-3xs"]} !important;
  }
  .btn,
  .ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 140px;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }
  .btnCancel,
  .ant-btn-default {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 140px;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme["@default-color"]} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: 48px !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }
`;
